"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryInvoiceInfo = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
class CountryInvoiceInfo {
    isVat = false;
    vatPercentage = 0;
    isReverseCharge = false;
    numberingTemplateId;
    invoiceCurrency = legacy_enums_1.Currency.Euro;
}
exports.CountryInvoiceInfo = CountryInvoiceInfo;
//# sourceMappingURL=CountryInvoiceInfo.js.map